import { View } from "react-native";
import Button from "../../../components/Button";
import { TooltipCustom } from "../../../components/Tooltip";
import CoverImageAiAssistantButton from "../../../components/CoverImageAiAssistantButton";
import { Image } from "../style";

const ViewImage = (props) => {
    const {
        showModal,
        img,
        orientation,
        user,
        horizontalCoverAi,
        verticalCoverAi,
    } = props;

    //adminRole "supportOnly" only allows access to notiications, community and comments
    const hasAdminRole = !user?.adminRole

    const content = (
        <Image source={{ uri: img }} resizeMode="cover">
            <View
                style={{
                    backgroundColor: "rgba(0,0,0,0.7)",
                    width: "100%",
                    height: "100%",
                    justifyContent: "center",
                    gap: 10,
                }}
            >
                {hasAdminRole &&
                    <View style={{ flexDirection: 'row', justifyContent: 'center', alignSelf: 'center', flexWrap: 'wrap', gap: 8 }}>
                        <Button
                            title={"+ Nova Capa Horizontal"}
                            onPress={() => showModal('horizontal')}
                            borderRadius={10}
                            fontSize={13}
                        />
                        <TooltipCustom
                            iconColor={"white"}
                            text={"A capa horizontal será exibida em todas as telas do app. Ela é necessária mesmo que exista uma capa vertical."}
                        />
                        {horizontalCoverAi ? (
                            <CoverImageAiAssistantButton
                                variant="overlay"
                                {...horizontalCoverAi}
                            />
                        ) : null}
                    </View>
                }
                {orientation === 'vertical' && hasAdminRole &&
                    <View style={{ flexDirection: 'row', justifyContent: 'center', alignSelf: 'center', flexWrap: 'wrap', gap: 8 }}>
                        <Button
                            title={"+ Nova Capa Vertical"}
                            onPress={() => showModal('vertical')}
                            borderRadius={10}
                            fontSize={13}
                        />
                        <TooltipCustom
                            iconColor={"white"}
                            text={"A capa vertical será exibida apenas na tela de catálogo. Lembre-se de adicionar a capa horizontal para as demais telas."}
                        />
                        {verticalCoverAi ? (
                            <CoverImageAiAssistantButton
                                variant="overlay"
                                {...verticalCoverAi}
                            />
                        ) : null}
                    </View>
                }
            </View>
        </Image>
    );

    return (
        <View
            style={{
                width: "100%",
                height: "100%",
                justifyContent: "center",
            }}
        >
            {content}
        </View>
    );
};

export default ViewImage;
